/** Format attack-patterns data by technique name for chart display */
export function attackPatternFormatting(items, selectedItems = [], attackPatternsDict, patterns, page) {
  Object.entries(items).forEach(([index, item]) => {
    const { id: itemId, 'attack-patterns': itemPatterns } = item
    if (selectedItems.indexOf(itemId) === -1 || !itemPatterns || itemPatterns === 'redacted') {
      return
    }

    Object.entries(itemPatterns).forEach(([attackName, attacks]) => {
      const patternBucket = patterns[attackName] || (patterns[attackName] = {})

      Object.entries(attacks).forEach(([index, pattern]) => {
        // NAUT-2846: Only restricts the attribution_scope for Mitre Attack explore feature, but not Actors/Malware.
        if (page === 'MitreExplore' && pattern.attribution_scope && pattern.attribution_scope !== 'confirmed') {
          return
        }
        const { id, sub_techniques: subTechniques = [] } = pattern
        const patternDetails = attackPatternsDict[id]
        const {
          attack_pattern_identifier: identifier,
          name: patternName,
          description,
        } = patternDetails

        subTechniques.forEach(subTechnique => {
          // NAUT-2846: Only restricts the attribution_scope for Mitre Attack explore feature, but not Actors/Malware.
          if (page === 'MitreExplore' && subTechnique.attribution_scope && subTechnique.attribution_scope !== 'confirmed') {
            return
          }
          const { id: subId, attribution_scope: subScope } = subTechnique
          const subPatternDetails = attackPatternsDict[subId]
          if (subPatternDetails) {
            const {
              attack_pattern_identifier: subIdentifier,
              name: techniqueName,
              description: subDescription
            } = subPatternDetails
            patternBucket[subIdentifier] || (patternBucket[subIdentifier] = {
              identifier: subIdentifier,
              name: techniqueName,
              parent: patternName,
              associations: [],
              description: subDescription,
              attribution_scope: subScope,
            })
            const { associations } = patternBucket[subIdentifier]
            associations.push(itemId)
          }
        })

        patternBucket[identifier] || (patternBucket[identifier] = {
          identifier,
          name: patternName,
          associations: [],
          parent: null,
          description,
          attribution_scope: pattern.attribution_scope
        })

        // If unique, add the item ID to the list for this pattern
        const { associations } = patternBucket[identifier]
        if (!associations.includes(itemId)) {
          associations.push(itemId)
        }
      })
    })
  })
  Object.entries(patterns).forEach(([attack, patternObj]) => {
    patterns[attack] = Object.values(patternObj)
  })
  return patterns
}
